export default {
    order: state => state.order,
    selectedRewards: state => state.selectedRewards,
    rewards: state => state.rewards,
}